/* eslint-disable react/no-string-refs */
import React, { useContext } from 'react';
import { Stack, Flex, Container, Box } from '@chakra-ui/react';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import OptionsButtons from './Header/OptionsButtons';
import { useDetectMobile } from '../../helpers/detectDevice';
import { ILayoutProps } from '../interfaces/layout/mainLayout';
import { useDetectIsLandingPage } from '../../helpers/getIsLandingPage';
// import { Helmet } from 'react-helmet-async';
import { t } from 'i18next';
// import useChangeLanguage from '../../hooks/useChangeLanguage';
import { MapContext } from '../../contexts/MapContext';

export default function MainLayout({
  children,
  naked,
  centered,
  unpadded,
  smallPadding,
  hideFooter,
  hideHeader,
  bigScreen,
  title = t('seo.title'),
  description = t('seo.description'),
  keywords = t('seo.keywords'),
  preloadPath,
  // canonicalLink = window.location.origin + window.location.pathname + window.location.search,
  ogImage = 'https://stflate.blob.core.windows.net/generic/logo.jpeg',
  noIndex = false,
}: ILayoutProps) {
  const mobile = useDetectMobile();
  const isLandingPage = useDetectIsLandingPage();
  const { mapIsShowed } = useContext(MapContext);

  // get current language
  // const { currentLang } = useChangeLanguage();
  // const ita = currentLang === 'it';
  return (
    <>
      {/* <Helmet>
        <title>{title}</title>
        <link
          rel="alternate"
          hrefLang="it"
          href={`https://flate.com${ita ? window.location.pathname : window.location.pathname.replace('/en/', '/it/')}`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`https://flate.com${ita ? window.location.pathname.replace('/it/', '/en/') : window.location.pathname}`}
        />
        <link rel="preload" href={preloadPath} as="image" />
        <meta property="title" content={title} />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link property="og:image" href={ogImage} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <link property="og:image" href={ogImage} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={ogImage} />
        <link property="og:url" href={window.location.href} />
        <link property="twitter:url" href={window.location.href} />
        {noIndex && <meta name="robots" content="noindex" />}
      </Helmet> */}
      <Stack minH="100vh" pos="relative">
        {!naked && !hideHeader && <Header />}
        <Flex direction="column" flex="1" justify={centered ? 'center' : 'flex-start'}>
          <Container
            maxW={bigScreen ? '1600px' : 'container.xl'}
            position="relative"
            px={{ base: mapIsShowed && !isLandingPage ? 0 : 3, md: bigScreen ? 2 : 6, lg: bigScreen ? 10 : 6 }}
            zIndex="0"
            pt={{ md: unpadded ? '0' : smallPadding ? '5' : '10' }}
            pb={{ base: '16', md: unpadded ? '0' : smallPadding ? '5' : '10' }}
          >
            {children}
          </Container>
        </Flex>
        {!naked && !hideFooter && <Footer />}
        {mobile && isLandingPage && (
          <Box bg="transparent" zIndex={3} position="sticky" bottom="0" py="1em">
            <OptionsButtons isMobile />
          </Box>
        )}
      </Stack>
    </>
  );
}
